module.exports = __webpack_public_path__ + "images/company_profile/icon_en01-09e18fddaea2b9620199885e9c0e9b48.png";